/**
 * ScrollableMenuNavigation Custom Element
 * Provides horizontal scrolling with arrow controls for mobile menu navigation
 */
class ScrollableMenuNavigation extends HTMLElement {
  constructor() {
    super();
    this.scrollContainer = null;
    this.leftArrow = null;
    this.rightArrow = null;
  }

  connectedCallback() {
    this.scrollContainer = this.querySelector('#scrollContainer');
    this.leftArrow = this.querySelector('#leftArrow');
    this.rightArrow = this.querySelector('#rightArrow');

    if (!this.scrollContainer || !this.leftArrow || !this.rightArrow) {
      console.warn('ScrollableMenuNavigation: Required elements not found');
      return;
    }

    this.init();
  }

  init() {
    if (!this.scrollContainer || !this.leftArrow || !this.rightArrow) return;

    // Get the actual scrollable element
    const scrollableElement = this.scrollContainer.querySelector('.menu-list__scroll-container');
    if (!scrollableElement) return;

    // Scroll behavior
    this.leftArrow.addEventListener('click', () => {
      scrollableElement.scrollBy({ left: -150, behavior: 'smooth' });
    });

    this.rightArrow.addEventListener('click', () => {
      scrollableElement.scrollBy({ left: 150, behavior: 'smooth' });
    });

    // Listen for scroll and resize
    scrollableElement.addEventListener('scroll', this.updateArrowVisibility.bind(this));
    window.addEventListener('resize', this.updateArrowVisibility.bind(this));
    window.addEventListener('load', this.updateArrowVisibility.bind(this));

    // Initial arrow visibility check with a small delay to ensure DOM is ready
    setTimeout(() => {
      this.updateArrowVisibility();
    }, 100);

    // Also check after a longer delay in case content loads dynamically
    setTimeout(() => {
      this.updateArrowVisibility();
    }, 500);
  }

  updateArrowVisibility() {
    if (!this.scrollContainer || !this.leftArrow || !this.rightArrow) return;

    // Get the actual scrollable element (menu-list__scroll-container)
    const scrollableElement = this.scrollContainer.querySelector('.menu-list__scroll-container');
    if (!scrollableElement) return;

    const scrollLeft = scrollableElement.scrollLeft;
    const maxScroll = scrollableElement.scrollWidth - scrollableElement.clientWidth;

    // Debug logging
    console.log('Scroll Debug:', {
      scrollLeft,
      scrollWidth: scrollableElement.scrollWidth,
      clientWidth: scrollableElement.clientWidth,
      maxScroll
    });

    // Hide both arrows if no scrolling is needed
    if (maxScroll <= 0) {
      this.leftArrow.classList.add('hidden');
      this.rightArrow.classList.add('hidden');
      return;
    }

    // Left arrow: show when scrolled right (hidden when at start)
    if (scrollLeft > 10) {
      this.leftArrow.classList.remove('hidden');
    } else {
      this.leftArrow.classList.add('hidden');
    }

    // Right arrow: show when can scroll right (hidden when at end)  
    if (scrollLeft < maxScroll - 10) {
      this.rightArrow.classList.remove('hidden');
    } else {
      this.rightArrow.classList.add('hidden');
    }
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.scrollContainer) {
      const scrollableElement = this.scrollContainer.querySelector('.menu-list__scroll-container');
      if (scrollableElement) {
        scrollableElement.removeEventListener('scroll', this.updateArrowVisibility.bind(this));
      }
    }
    window.removeEventListener('resize', this.updateArrowVisibility.bind(this));
    window.removeEventListener('load', this.updateArrowVisibility.bind(this));
  }
}

// Register the custom element
if (!customElements.get('scrollable-menu-navigation')) {
  customElements.define('scrollable-menu-navigation', ScrollableMenuNavigation);
} 